import { Route } from 'router5'
import { startsWithSegment } from 'router5-helpers'

// Recursively traverse routes, until route matching the name is found.
// Throws error if none is found.
export function getRoute<TRoute extends Route>(
  routes: TRoute[],
  name: string
): TRoute | undefined {
  // tslint:disable-next-line:prefer-for-of
  for (let i = 0; i < routes.length; i += 1) {
    const route = routes[i]
    if (route.name === name) {
      return route
    }

    // Segment is child route of current route.
    if (startsWithSegment(name, route.name) && route.children) {
      const segments = name.split('.')
      segments.shift()
      if (segments.length > 0) {
        return getRoute(route.children as TRoute[], segments.join('.'))
      }
    }
  }

  return undefined
}

/**
 * Using getRoute, finds component of route.
 * Supplying a route name will find a child route of node with given name.
 * E.g.:
 * getComponent(admin, '') => admin
 * getComponent(admin.crowdfunding, admin) => crowdfunding
 * getComponent(admin.crowdfunding.prospects, admin.crowdfunding) => prospects
 * @param name Current route name, childroutes separated with dots (e.g. admin.crowdfunding)
 * @param nodeName The node from which to select from. If set, will find child route of node with name.
 * @returns Component (if exists), otherwise null.
 */
export function getRouteFromNode<TRoute extends Route>(
  routes: TRoute[],
  name: string,
  nodeName = ''
): TRoute | undefined {
  const segments = name.split('.') // Break route in segments (levels)
  const nodeSegments = nodeName.split('.')

  const depth = nodeName === '' ? 1 : nodeSegments.length + 1

  const segment = segments.slice(0, depth).join('.')

  const route = getRoute(routes, segment)

  return route
}
